import { html } from 'lit';

export const iconZoomIn = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6.57692 5.24489C6.73528 5.24489 6.875 5.10517 6.875 4.9375C6.875 4.77915 6.73528 4.63942 6.57692 4.64874H5.23558V3.30739C5.23558 3.13972 5.09585 3 4.9375 3C4.76983 3 4.63942 3.13972 4.63942 3.30739V4.64874H3.29808C3.13041 4.64874 3 4.77915 3 4.9375C3 5.10517 3.13041 5.24489 3.29808 5.24489H4.63942V6.58624C4.63942 6.74459 4.76983 6.875 4.9375 6.875C5.09585 6.875 5.23558 6.74459 5.23558 6.58624V5.24489H6.57692Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8125 11.8359C12.0469 11.625 12.0469 11.2734 11.8125 11.0391L8.67188 7.89844C9.35156 7.07812 9.72656 6.02344 9.72656 4.875C9.72656 2.20312 7.52344 0 4.85156 0C2.15625 0 0 2.20312 0 4.875C0 7.57031 2.17969 9.75 4.85156 9.75C5.97656 9.75 7.03125 9.375 7.875 8.69531L11.0156 11.8359C11.1328 11.9531 11.2734 12 11.4375 12C11.5781 12 11.7188 11.9531 11.8125 11.8359ZM4.875 8.625C2.78906 8.625 1.125 6.96094 1.125 4.875C1.125 2.8125 2.78906 1.125 4.875 1.125C6.9375 1.125 8.625 2.8125 8.625 4.875C8.625 6.96094 6.9375 8.625 4.875 8.625Z"
      fill="currentColor"
    />
  </svg>
`;
